<template>
  <div>
    <v-card-text style="color: black">
        <h4 class="mb-2">3. {{ $t("agenda.lblSelectObserver") }}</h4>
        <p>{{ $t("agenda.lblObserverSubHeading") }}</p>
        <v-row
          no-gutters
          class="mb-2"
          v-for="(signer, index) in selectObservers"
          :key="signer.id"
        >
          <v-col>
            <v-card class="mx-auto" outlined>
              <!-- <v-container fill-height fluid> -->
              <v-row
                no-gutters
                align="center"
                justify="space-between"
                class="mx-3 pa-3"
              >
                <v-col cols="5">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" style="font-size: 15px">
                        {{ `${index + 1}.` }}
                        <v-avatar
                          v-if="signer.email"
                          left
                          v-bind="attrs"
                          v-on="on"
                          size="24"
                        >
                          <v-img
                            v-if="signer.profilePhoto"
                            contain
                            :src="signer.profilePhoto"
                          ></v-img>
                          <v-img
                            v-else
                            contain
                            src="@/assets/images/NoPhotoIcon.png"
                          ></v-img>
                        </v-avatar>
                        <span
                          class="ml-2"
                          v-if="signer.firstName && signer.lastName"
                          >{{ `${signer.firstName} ${signer.lastName}` }}</span
                        >
                        <span class="ml-2" v-else>{{ signer.email }}</span>
                      </span>
                    </template>
                    <span> {{ signer.email }} </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" v-if="signer.user_id !== $auth.user.user_id">
                  <signer-action
                    @onDelete="confirmDelete(signer.id)"
                    :upDisabled="index === 0"
                    :downDisabled="index === selectObservers.length - 1"
                  ></signer-action>
                </v-col>
              </v-row>
              <!-- </v-container> -->
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primary"
              small
              text
              v-bind="attrs"
              v-on="on"
              @click="openSignerSelectDialog"
            >
              <v-icon small>mdi-plus</v-icon>
              <span>{{ $t("agenda.lblAddObserver") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("agenda.lblAddObserver") }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="primaryDark"
              v-bind="attrs"
              v-on="on"
              @click="nextStep"
              :disabled="isButtonDisabled"
              ><span>{{ $t("btnSendEmailToSigner") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnSendEmailToSigner") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click="onBack"
              ><span>{{ $t("Back") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("Back") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              color="secondary"
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
      <signer-select
      v-if="showSignerSelectDialog"
      v-model="showSignerSelectDialog"
      :signerList.sync="selectObservers"
      :attendeesList="observerListItems"
      :label="$t('agenda.lblSelectObserver')"
      signerType="observer"
    >
      <template #heading>
        {{ $t('agenda.lblAddRemoveObserver') }}
      </template>
    </signer-select>
      <confirm-dialog ref="confirmDelete" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SignerAction from "./SignerAction.vue";
import SignerOptions from "./SignerOptions.vue";
import SignerSelect from "./SignerSelect.vue";
import ConfirmDialog from "../../ConfirmDialog.vue";
export default {
  components: {
    SignerAction,
    SignerOptions,
    SignerSelect,
    ConfirmDialog,
  },
  name: "AddSignerStep",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    signerList: Array,
    selectedSigner: Array
  },
  data() {
    return {
      selectSignerList: [],
      showSignerSelectDialog: false,
    };
  },
  computed: {
    ...mapState({
      getObserverList: (state) => state.agenda.observerList,
      getProvider: (state) => state.agenda.e_signature_provider,
    }),
    loaderText() {
      return this.$t("LoaderText");
    },
    isUserSigner(){
      const loggedUserId = this.loggedUser.user_id;
      const isexist = this.selectedSigner.findIndex(user => user.id === loggedUserId)
      return isexist !== -1 ? true : false;;
    },
    isButtonDisabled(){
      if(this.getProvider && this.getProvider === "Cygnature"){
        return false
      }
      return this.selectObservers.length === 0;
    },
    loggedUser(){
      const user = this.$auth.user || {}; // Prevents errors if user is null/undefined
      return {
        id: user.user_id,
        user_id: user.user_id, // Remove if redundant
        email: user.email,
        registered_email: user.email, // Remove if redundant
        firstName: user.first_name,
        lastName: user.last_name,
        profilePhoto: user.profile_photo_thumbnail,
        disabled: true,
      };
    },
    selectObservers: {
    get() {
      // Ensure the user is in the list without modifying the original array
      if (((this.getProvider && this.getProvider !== "Cygnature") || !this.isUserSigner) && !this.selectSignerList.some(user => user.id === this.loggedUser.user_id)) {
        return [...this.selectSignerList, this.loggedUser]; // Return a new array instead
      }
      return this.selectSignerList;
      },
      set(value) {
        if (((this.getProvider && this.getProvider !== "Cygnature") || !this.isUserSigner) && !value.some(user => user.id === this.loggedUser.user_id)) {
          this.selectSignerList = [...value, this.loggedUser]; // Create a new array to trigger reactivity
        } else {
          this.selectSignerList = value;
        }
      }
    },
    observerListItems() {
      
      const loggedUserId = this.loggedUser.user_id;
      
      if (!this.getObserverList) return [];

      // Clone the observer list to avoid mutating the original state
      let observerList = [...this.getObserverList];

      // Check if logged user exists in the list
      const userIndex = observerList.findIndex(user => user.user_id === loggedUserId);

      if(this.getProvider && this.getProvider === 'Cygnature'){
        const filteredObserverList = observerList.filter(observer => {
            return !this.selectedSigner.some(user => user.id === observer.id);
          });
          return filteredObserverList;
      }

      if (userIndex !== -1) {
        // If user exists, add disabled key
        observerList[userIndex] = { ...observerList[userIndex], disabled: true };
      } else {
        // If user doesn't exist, add them with disabled: true
        observerList.push({ ...this.loggedUser, disabled: true });
      }
      return observerList;
    }
  },

  methods: {
    ...mapActions({
      sendMOMSignatureDocumentEmail: "agenda/sendMOMSignatureDocumentEmail",
    }),
    close,
    confirmDelete,
    onBack,
    nextStep,
    openSignerSelectDialog() {
      this.showSignerSelectDialog = true;
    },
  },
};
function nextStep(){
  this.$emit(
    "update:signerList",
    this.selectObservers
  );
  this.$emit("nextStep", this.selectObservers);
}

async function confirmDelete(id) {
  try {
    if (
      await this.$refs.confirmDelete.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("agenda.lblDeleteMessage")
      )
    ) {
      const findIndex = this.selectObservers.findIndex(
        (signer) => signer.id === id
      );

      if (findIndex !== -1) {
        this.selectObservers.splice(findIndex, 1);
        this.$emit(
          "update:signerList",
          this.selectObservers
        );
      }
    }
  } catch (error) {
    this.Loaderloading = false;
  }
}


function onBack() {
  this.$emit("back");
}

function close() {
  this.$emit("close");
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>